function firstMeaningfulLine(message: string): string {
  return message.split(/\r?\n/).find((line) => line.trim())?.trim() || message.trim();
}

export function sanitizeApiErrorMessage(rawMessage: string, fallbackMessage: string): string {
  const message = rawMessage.trim();

  if (!message) {
    return fallbackMessage;
  }

  const firstLine = firstMeaningfulLine(message).replace(/^error:\s*/i, '').trim();

  if (!firstLine) {
    return fallbackMessage;
  }

  const looksInternal =
    /cannot invoke\b/i.test(firstLine) ||
    /because\s+["'][^"']+["']\s+is\s+null/i.test(firstLine) ||
    /\bnullpointerexception\b/i.test(firstLine) ||
    /\b(exception|stack trace|traceback)\b/i.test(firstLine) ||
    /\bjava\.[\w.]+/i.test(firstLine) ||
    /\borg\.springframework\b/i.test(firstLine) ||
    /\bco\.za\.shiftwagon\.[\w.]+/i.test(firstLine) ||
    /^\s*at\s+[\w.$]+\([\w.$]+:\d+\)\s*$/i.test(firstLine);

  return looksInternal ? fallbackMessage : firstLine;
}
